import { action } from 'satcheljs';

export interface OnMeetingActionCompletedActionMessage {
    targetWindow: Window | undefined;
}
export const onMeetingActionCompleted: (
    targetWindow: Window | undefined
) => OnMeetingActionCompletedActionMessage = action(
    'onMeetingActionCompleted',
    (targetWindow: Window | undefined): OnMeetingActionCompletedActionMessage => ({
        targetWindow,
    })
);
